export const getHomeData = () => {
  return {
    url: '/hq/home-page-data',
    method: 'get'
  };
};
export const getAdvertisement = () => {
  return {
    url: '/adapi/ad/home-page',
    method: 'get',
    params: {
      rendom: Math.random()
    }
  };
};
export const getSwiperArticle = () => {
  return {
    url: '/api/recommend/article/getList',
    method: 'get'
  };
};

export const getIndexArticle = ({ tags, page, count }) => {
  return {
    url: '/api/tags/articles',
    method: 'get',
    params: {
      tags,
      page,
      count
    }
  };
};

export const getFreeResearchReports = () => {
  return {
    url: '/api/research-report-groups/1/free-research-reports',
    method: 'get'
  };
};

export const getPayResearchReports = ({ createTimestamp }) => {
  return {
    url: '/api/research-report-groups/1/pay-research-reports',
    method: 'get',
    params: {
      createTimestamp
    }
  };
};

export const getTags = () => {
  return {
    url: '/api/tags/all',
    method: 'get'
  };
};

export const infidtbList = ({ liveChannelId, liveId, limit }) => {
  return {
    // url: `/api/dtb/list?timestamp=${timestamp}`,
    url: `/api/live-channels/${liveChannelId}/lives`,
    method: 'get',
    params: {
      liveId,
      limit
    }
  };
};

export const getNewsData = ({ createDate, count }) => {
  return {
    url: '/api/news/filter/list',
    method: 'get',
    params: {
      createDate,
      count
    }
  };
};

export const getCommandList = ({ page, count, random = Math.random() }) => {
  return {
    url: '/api/column/recommend',
    method: 'get',
    params: {
      page,
      count,
      random
    }
  };
};

export const getArticleDetail = ({ id, headers }) => {
  if (headers) {
    return {
      url: `/api/post/${id}?random=${Math.random()}`,
      method: 'get',
      headers: headers
    };
  } else {
    return {
      url: `/api/post/${id}?random=${Math.random()}`,
      method: 'get'
    };
  }
};

export const getArticleRelated = ({ count, postId }) => {
  return {
    url: '/api/recommend/posts',
    method: 'get',
    params: {
      count,
      postId
    }
  };
};

export const getAuthorArticle = ({ page, count, userId }) => {
  return {
    url: '/api/post',
    method: 'get',
    params: {
      page,
      count,
      userId
    }
  };
};

export const getHotColumns = ({ page, count, random = Math.random() }) => {
  return {
    url: '/api/column/hot',
    method: 'get',
    params: {
      page,
      count,
      random
    }
  };
};

export const getRecommendColumns = ({
  page,
  count,
  random = Math.random()
}) => {
  return {
    url: '/api/column/recommend',
    method: 'get',
    params: {
      page,
      count,
      random
    }
  };
};

export const getColumnArticleList = ({ page, count, version = 2.0 }) => {
  return {
    url: '/api/columnArticle/getSelected',
    method: 'get',
    params: {
      page,
      count,
      version
    }
  };
};

export const getNews = ({ createDate, count, type }) => {
  return {
    url: '/api/news/filter/list',
    method: 'get',
    params: {
      createDate,
      count,
      type
    }
  };
};

export const getNewsPage = ({ page, limit }) => {
  return {
    url: '/api/news/list/v2',
    method: 'get',
    params: {
      page,
      limit
    }
  };
};

export const stockGains = ({ stockCodes }) => {
  return {
    url: '/hq/stocks/net-change',
    method: 'get',
    params: {
      stockCodes
    }
  };
};

export const getNewsLabel = () => {
  return {
    url: '/api/news/type/filterLabel',
    method: 'get'
  };
};

export const getNewsInfo = id => {
  return {
    url: `/api/news/${id}`,
    method: 'get'
  };
};
//主题相关接口
// 1.获取全部主题
export const allTheme = ({ page, limit, headers }) => {
  if (headers) {
    return {
      url: '/api/subjects',
      method: 'get',
      headers: headers,
      params: {
        page,
        limit
      }
    };
  } else {
    return {
      url: '/api/subjects',
      method: 'get',
      params: {
        page,
        limit
      }
    };
  }
};
//2.获取热门主题
export const hotTheme = ({ page, headers }) => {
  if (headers) {
    return {
      url: '/api/subjects/hot',
      method: 'get',
      headers: headers,
      params: {
        page
      }
    };
  } else {
    return {
      url: '/api/subjects/hot',
      method: 'get',
      params: {
        page
      }
    };
  }
};
//3.获取我的主题
export const getMyFocus = ({ id, page, isHot, limit, headers }) => {
  if (headers) {
    return {
      // url: `/api/subjects/${id}/followed`,
      url: '/api/subjects/-1/followed',
      method: 'get',
      headers: headers,
      params: {
        page,
        isHot,
        limit
      }
    };
  } else {
    return {
      // url: `/api/subjects/${id}/followed`,
      url: '/api/subjects/-1/followed',
      method: 'get',
      params: {
        page,
        isHot,
        limit
      }
    };
  }
};
//4.获取主题下的文章列表等
export const getContentList = ({ subjectId, isChoice, createTimestamp }) => {
  return {
    url: `/api/subjects/${subjectId}/contents`,
    method: 'get',
    params: {
      isChoice,
      createTimestamp
    }
  };
};
//5.主题详情  服务端主动设置headers,客户端无需设置
export const getSubjectDetail = ({ subjectId, headers }) => {
  if (headers) {
    return {
      url: `/api/subjects/${subjectId}/detail`,
      headers: headers,
      method: 'get'
    };
  } else {
    return {
      url: `/api/subjects/${subjectId}/detail`,
      method: 'get'
    };
  }
};
// export const getStocksNews = ({ page = 1, count = 2, stock }) => {
//   return {
//     url: '/api/news/list',
//     method: 'get',
//     params: {
//       page,
//       count,
//       stock
//     }
//   }
// }
export const getStocksNews = ({ page = 1, count = 2, keyword, filterIds }) => {
  return {
    url: '/api/news/search',
    method: 'get',
    params: {
      page,
      count,
      keyword,
      filterIds
    }
  };
};

export const getStocksDetails = ({ stockCodes }) => {
  return {
    url: '/quote/api/stocks/base-data',
    method: 'get',
    params: {
      stockCodes
    }
  };
};

export const getDtbList = ({ onlyShowImportant, liveId, limit }) => {
  return {
    // url: `/api/dtb/list?timestamp=${timestamp}`,
    url: '/api/live-channels/all/lives',
    method: 'get',
    params: {
      onlyShowImportant,
      liveId,
      limit
    }
  };
};

export const getDtbImportList = ({
  onlyShowImportant = true,
  liveId,
  limit
}) => {
  return {
    // url: `/api/dtb/list?timestamp=${timestamp}`,
    url: '/api/live-channels/all/lives',
    method: 'get',
    params: {
      onlyShowImportant,
      limit,
      liveId
    }
  };
};

export const getDtbDetail = id => {
  return {
    url: `/api/dtb/getByCreateTime?id=${id}`,
    method: 'get'
  };
};

export const getHotArticle = type => {
  return {
    url: `/api/posts/chart?type=${type}&page=1&limit=10`,
    method: 'get'
  };
};

export const getUserInfo = ({ userId }) => {
  return {
    url: '/api/user/get',
    method: 'get',
    params: {
      userId
    }
  };
};

export const getUserDnamic = ({ article, userId, timestamp, count }) => {
  return {
    url: '/api/community/dynamic/my-dynamics',
    method: 'get',
    params: {
      article,
      userId,
      timestamp,
      count
    }
  };
};

export const doIndexSearch = ({ keyword, count, page }) => {
  return {
    url: '/api/search/searchBox',
    method: 'get',
    params: {
      keyword,
      count,
      page
    }
  };
};
/*
搜索接口，整合接口
/api/search/[searchType]?[keyword,count,page]
searchType目前的值可以为：
post,columnArticle,stock,user,news
今后可能出现话题等
*/
export const searchAllThings = ({ searchType, keyword, count, page, type }) => {
  let url = `/api/search/${searchType}`;
  return {
    url,
    method: 'get',
    params: {
      keyword,
      count,
      page,
      type
    }
  };
};

/*
获取股票价格、涨跌幅、以及画图信息
*/
export const getStockPriceInfo = ({ stocks }) => {
  return {
    url: '/quote/api/stocks/base-data',
    method: 'get',
    params: {
      stockCodes: stocks
    }
  };
};

/*
获取文章页评论列表
*/
export const getCommentsList = ({ pageId, page, count }) => {
  return {
    url: `/api/post/${pageId}/comment`,
    method: 'get',
    params: {
      r: parseInt(Math.random() * 10000),
      page,
      count
    }
  };
};

/*
评论文章
*/
export const sendComment = ({ pageId, content }) => {
  return {
    url: `/api/post/${pageId}/comment`,
    method: 'post',
    data: {
      content
    }
  };
};

/*
回复评论
*/
export const replyComment = ({ pageId, content, replyCommentId, replyUid }) => {
  return {
    url: `/api/post/${pageId}/comment`,
    method: 'post',
    data: {
      content,
      replyCommentId,
      replyUid
    }
  };
};

/*
删除评论
*/
export const deleteSelfComment = ({ commentId }) => {
  return {
    url: `/api/comments/${commentId}/v1`,
    method: 'DELETE'
  };
};

// 股票行情页面部分（主页）
//一级页面指数行情
export const getIndexMarket = () => {
  return {
    url: '/hq/home-page/hk-index-chart/v1',
    method: 'get'
  };
};
//一级页面行情排行榜
export const getMarketRange = ({ sort, order }) => {
  return {
    url: '/hq/hk/boards/v1',
    method: 'get',
    params: {
      sort,
      order
    }
  };
};
//一级页面热度排行榜
export const getHotRange = () => {
  return {
    url: '/tapi/xueqiu/Leaderboard/v1/',
    method: 'get'
  };
};
//港股异动
export const getHKChange = () => {
  return {
    url: '/api/news/filter/list?createDate=&count=8&type=32',
    method: 'get'
  };
};

//公司总览
export const getCompanySum = () => {
  return {
    url: '/api/news/filter/list?createDate=&count=8&type=27',
    method: 'get'
  };
};

// 公司详情
export const getCompanyInfo = () => {
  return {
    url: '/api/news/filter/list?createDate=&count=8&type=33',
    method: 'get'
  };
};

//搜索框
export const getStockList = ({ stockCodes }) => {
  return {
    url: '/api/search/stockForLUAndHK',
    method: 'get',
    params: {
      keyword: stockCodes,
      tranTypes: 'szhk,shhk'
    }
  };
};

//行情排行榜的二级页面
export const getSecondMarketRange = ({ type, sort, order, page, limit }) => {
  return {
    url: `/hq/${type}/stock/rank/detail/v1`,
    method: 'get',
    params: {
      sort,
      order,
      page,
      limit
    }
  };
};
//热度排行榜二级页面
export const getSecondHotRange = ({ sortType, order, page, count }) => {
  return {
    url: '/mapi/market/hotRange/v1/',
    method: 'get',
    params: {
      sortType,
      order,
      page,
      count
    }
  };
};

//自选股相关
//判断是否在用户自选表中
export const isUserStock = ({ stockCodes }) => {
  return {
    url: '/api/userstock/isUserStock',
    method: 'get',
    params: {
      stockCodes
    }
  };
};
//添加新自选股票
export const addUserStock = ({ stockCode, stockType }) => {
  return {
    url: '/api/userstock/add',
    method: 'post',
    data: {
      stockCode,
      stockType
    }
  };
};
//删除自选股票
export const deleteUserStock = ({ stockCodes }) => {
  return {
    url: '/api/userstock/delete',
    method: 'post',
    params: {
      stockCodes
    }
  };
};
//获取用户自选股列表
export const getUserStockList = ({ userId, page, limit }) => {
  return {
    url: '/api/userstock',
    method: 'get',
    params: {
      userId,
      page,
      limit
    }
  };
};
//个股分时图
export const getM = ({ market, stockCode }) => {
  return {
    url: `/hq/${market}/minute-line/${stockCode}/v2`,
    method: 'get'
  };
};

//个股K线图
export const getK = ({
  market,
  klineType,
  stockCode,
  count,
  timestamp,
  rightsType
}) => {
  return {
    url: `/hq/${market}/kline/${klineType}/${stockCode}/v2`,
    method: 'get',
    params: {
      count,
      timestamp,
      rightsType
    }
  };
};
//沽空空仓数据
export const getShortPosition = ({ stockType, stockCode }) => {
  return {
    url: `/data/api/short-position/table/${stockType}/${stockCode}`,
    method: 'get'
  };
};
//沽空卖空数据
export const getShortData = ({ monthCount, stockType, stockCode }) => {
  return {
    url: `/data/api/short-data/list/${monthCount}/${stockType}/${stockCode}`,
    method: 'get'
  };
};
//判断有没有沽空数据
export const haveShort = ({ stockCode }) => {
  return {
    url: `/quote/api/quote/isshortselling/${stockCode}`,
    method: 'get'
  };
};
//获取个股行情信息
export const getStocks = ({ market, stockCode }) => {
  return {
    url: `/hq/${market}/quote-info/${stockCode}/v1`,
    method: 'get'
  };
};
//获取美股信息
export const getUS = ({ market, stockCode }) => {
  return {
    url: `/hq/${market}/quote-info/${stockCode}/v1`,
    method: 'get'
  };
};

export const searchStock = ({ page, count, keyword, market }) => {
  return {
    url: '/api/search/stock',
    method: 'get',
    params: {
      page,
      count,
      keyword,
      market
    }
  };
};

// 帖子点赞
export const likePost = ({ postId }) => {
  return {
    url: `/api/post/${postId}/like/add`,
    method: 'post'
  };
};

// 帖子取消点赞
export const cancelLikePost = ({ postId }) => {
  return {
    url: `/api/post/${postId}/like/delete`,
    method: 'post'
  };
};
// 帖子收藏
export const addFavPost = ({ postId }) => {
  return {
    url: `/api/post/${postId}/fav/add`,
    method: 'post'
  };
};

// 帖子取消收藏
export const delFavPost = ({ source, postId }) => {
  return {
    url: `/api/favorite/${source}/${postId}/v2`,
    method: 'delete'
  };
};

// 获取rss文章详情
export const getRssInfo = id => {
  return {
    url: '/data/api/rss/detail',
    method: 'get',
    params: {
      id
    }
  };
};
//股票详情页 F10股票图表

//公司信息简介
export const getCompanyProfile = ({ market, stockCode }) => {
  return {
    url: `/data/api/chart/company-info/${market}/${stockCode}/v2`,
    method: 'get'
  };
};
//F10股权结构饼图
export const getCompanyStructure = ({ market, stockCode }) => {
  return {
    url: `/data/api/chart/ratio/${market}/${stockCode}/v2`,
    method: 'get'
    // params: {
    //   market,
    //   stockCode
    // }
  };
};
//获取F10年报和半年报的财务数据
export const getFinancialData = ({ market, stockCode }) => {
  return {
    url: `/data/api/${market}/f10/finance/${stockCode}/v1`,
    method: 'get',
    params: {
      market,
      stockCode
    }
  };
};

// 股票详情页 研究
export const getPostOfStock = ({ stockCode, page, count }) => {
  return {
    url: '/api/post/list',
    method: 'get',
    params: {
      stockCode,
      page,
      count
    }
  };
};

// 股票详情页 事件
export const getNewsOfStock = ({ stock, page, count }) => {
  return {
    url: '/api/news/list',
    method: 'get',
    params: {
      stock,
      page,
      count
    }
  };
};

// 股票详情页 公告
export const getAnnanoticeOfStock = ({ stockCode, page, count }) => {
  return {
    url: '/api/annAnotice/stock/announcements',
    method: 'get',
    params: {
      stockCode,
      page,
      count
    }
  };
};

// 股票详情页 评论列表
export const getCommentOfStock = ({ stockCode, timestamp, count }) => {
  return {
    url: '/api/stock-comment/posts',
    method: 'get',
    params: {
      stockCode,
      timestamp
    }
  };
};
// /solr/live/search?keyword=施乐公司

// 获取直播筛选
export const searchSolrLive = ({
  keyword,
  startTimestamp,
  endTimestamp,
  page,
  count
}) => {
  return {
    url: '/api/live/search/v1',
    method: 'get',
    params: {
      keyword,
      startTimestamp,
      endTimestamp,
      page,
      count
    }
  };
};

// 股票详情页 创建股票评论
// title已经取消
export const sendCommentOfStock = ({ content, pictureUrls, stocks, title }) => {
  return {
    url: '/api/stock-comment/post',
    method: 'put',
    data: {
      content,
      pictureUrls,
      stocks,
      title
    }
  };
};

// 股票详情页 评论股票评论   以及 回复股票评论的评论
export const sendCommentOfStockComment = ({
  content,
  pictureUrls,
  postId,
  replyCommentId
}) => {
  return {
    url: '/api/stock-comment/comment',
    method: 'put',
    data: {
      content,
      pictureUrls,
      postId,
      replyCommentId // 回复股票评论的评论的id 可以为空
    }
  };
};

// 股票详情页  点赞股票评论

export const likeStockComment = ({ id, type }) => {
  return {
    url: '/api/stock-comment/like',
    method: 'put',
    data: {
      id,
      type
    }
  };
};
// 股票详情   取消股票评论点赞
export const unlikeStockComment = ({ id, type }) => {
  return {
    url: `/api/stock-comment/like/${type}/${id}`,
    method: 'delete'
  };
};

// 股票详情  删除股票评论
export const deleteSelfStockComment = ({ id }) => {
  return {
    url: `/api/stock-comment/post/${id}`,
    method: 'delete'
  };
};

// 上传图片接口，
export const uploadFilePic = formData => {
  return {
    url: '/file/api/file/post-img',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  };
};
//  上传pdf接口
export const uploadFilePDF = formData => {
  return {
    url: '/api/file/post/pdf',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  };
};

// 获取用户申请状态
export const getAuthorAuditStatu = () => {
  return {
    url: '/api/column/apply/user/apply-status/v1',
    method: 'get'
  };
};
// 用户申请作者
export const sendAuthorAudit = ({
  type,
  name,
  idCard,
  articleLinks,
  countryCode,
  phone,
  verificationCode,
  email,
  enterpriseName,
  businessLicenseNum,
  businessLicensePicture,
  internetServiceLicensePicture
}) => {
  return {
    url: '/api/column/apply/v2',
    method: 'post',
    data: {
      type,
      name,
      idCard,
      articleLinks,
      countryCode,
      phone,
      verificationCode,
      email,
      enterpriseName,
      businessLicenseNum,
      businessLicensePicture,
      internetServiceLicensePicture
    }
  };
};

// 获取最近的申请失败记录
export const getAuthorAudit = () => {
  return {
    url: '/api/column/apply/user/apply/v1',
    method: 'get'
  };
};

// 编辑申请记录
export const putAuthorAudit = ({
  type,
  name,
  idCard,
  articleLinks,
  countryCode,
  phone,
  verificationCode,
  email,
  enterpriseName,
  businessLicenseNum,
  businessLicensePicture,
  internetServiceLicensePicture,
  id
}) => {
  return {
    url: `/api/column/apply/${id}/v1`,
    method: 'put',
    data: {
      type,
      name,
      idCard,
      articleLinks,
      countryCode,
      phone,
      verificationCode,
      email,
      enterpriseName,
      businessLicenseNum,
      businessLicensePicture,
      internetServiceLicensePicture
    }
  };
};
//用户申请状态查询
export const applicationStatus = () => {
  return {
    url: '/api/column/apply/user/apply-status/v1',
    method: 'get'
  };
};

// 会员列表
export const vipList = () => {
  return {
    url: '/api/vips/v1',
    method: 'get'
  };
};
// 会员权益
export const vipEquity = () => {
  return {
    url: '/api/vips-equity/v1',
    method: 'get'
  };
};
//可购列表（老接口，只有一个内容）
export const purchaseList = groupId => {
  return {
    url: '/api/purchase/goods-list/v1',
    method: 'get',
    params: {
      groupId
    }
  };
};
// 所有可够列表（新接口，包含所有内容，如升级或者续费)
export const purchaseListV2 = (groupId, headers) => {
  if (headers) {
    return {
      url: '/api/purchase/web/goods-list/v1',
      method: 'get',
      headers,
      params: {
        groupId
      }
    };
  } else {
    return {
      url: '/api/purchase/web/goods-list/v1',
      method: 'get',
      params: {
        groupId
      }
    };
  }
};
//新增收货地址
export const addAdress = ({
  name,
  countryCode,
  phoneNum,
  country,
  state,
  city,
  address
}) => {
  return {
    url: '/api/user-address/v1',
    method: 'post',
    data: {
      name,
      countryCode,
      phoneNum,
      country,
      state,
      city,
      address
    }
  };
};

// banner 图 默认vip
export const getBanner = ({ type = 'vip' }) => {
  return {
    url: `/api/channels/${type}/banner`,
    method: 'get'
  };
};
//支付二维码
export const memberPayment = ({
  goodsId,
  currency,
  amount,
  channel,
  sign,
  couponId
}) => {
  return {
    url: '/transaction/api/recharge/v2',
    method: 'post',
    data: {
      goodsId,
      currency,
      amount,
      channel,
      sign,
      couponId
    }
  };
};
//支付结果返回
export const getPaymentResult = orderId => {
  return {
    url: `/transaction/api/recharge-status/${orderId}`,
    method: 'post',
    progress: false,
    data: {
      orderId
    }
  };
};

// 会员相关文章目录tab
export const vipArticleIndex = () => {
  return {
    url: '/api/vips-equity/article-equities/v1',
    method: 'get'
  };
};

// 会员相关分类文章列表

export const vipArticleList = (
  type,
  timestamp = parseInt(`${+new Date() / 1000} `),
  loaded = 15
) => {
  return {
    url: `/api/vips-equity/article-equities/${type}/articles/v1`,
    method: 'get',
    params: {
      loaded,
      timestamp
    }
  };
};

// 获取会员权益最新文章列表
export const vipArticleListAll = ({
  timestamp = parseInt(`${+new Date() / 1000} `),
  loaded = 15
} = {}) => {
  return {
    url: '/api/vips-equity/article-equities/articles/v1',
    method: 'get',
    params: {
      loaded,
      timestamp
    }
  };
};

// 获取会员用户地址
export const getUserAddress = () => {
  return {
    url: '/api/user-address/v1',
    method: 'get',
    headers: {
      shortVersion: '6.10.0'
    }
  };
};
